module.exports = __webpack_public_path__ + "static/media/icomoon.b8c4f21e.ttf";